import { addLocaleData } from "react-intl";
import en from "react-intl/locale-data/en";
import sv from "react-intl/locale-data/sv";
import is from "react-intl/locale-data/is";
import constants from "common/constants";
/**
 * Add all supported locale codes and locale data packages here.
 * NOTE that just the Locale.code is stored in the State.
 */

export const Locale = {
  EN: { code: constants.appLanguages.en, labelId: "app.locale-en" },
  SV: { code: constants.appLanguages.sv, labelId: "app.locale-sv" },
  IS: { code: constants.appLanguages.is, labelId: "app.locale-is" }
};

export const Locales = [Locale.EN, Locale.SV];

export const DEFAULT_LOCALE = Locale.EN;
export const configureLocaleData = () => addLocaleData([...en, ...sv, ...is]);



// WEBPACK FOOTER //
// ./src/modules/i18n/locale-config.js